export class AnimationManager {
    animationTimerHandle: number;
    animationEndCallback: Function;
    constructor() {
        this.animationTimerHandle = null;
        this.animationEndCallback = null;
    }
    after(duration: number, doAction: Function) {
        this.endanimation();
        this.animationEndCallback = doAction;
        this.animationTimerHandle = window.setTimeout(() => this.endanimation(), duration);
    }
    endanimation() {
        var action = this.animationEndCallback;
        this.animationEndCallback = null;
        var handle = this.animationTimerHandle;
        this.animationTimerHandle = null;
        if (handle) {
            clearTimeout(handle);
        }
        if (action) {
            action();
        }
    }
}